module.exports = __webpack_public_path__ + "img/汕头白天鹅酒店.dff03c4b.png";